// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"multiply"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.1823 8.81836L12.0003 12.0003M12.0003 12.0003L8.81836 15.1823M12.0003 12.0003L15.1823 15.1823M12.0003 12.0003L8.81836 8.81836","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MultiplyIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'multiply',
    ref,
    icon: element,
  },
));

MultiplyIcon.displayName = 'MultiplyIcon';

export default MultiplyIcon;
